






























































import {
  defineComponent,
  PropType,
  ref,
  computed
} from '~/utils/nuxt3-migration'
import { SmartResultSection } from '~/models/search-bar'
import SmartSearchbarAutocompleteSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarAutocompleteSuggestion.vue'
import SmartSearchbarActionSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarActionSuggestion.vue'
import SmartSearchbarClassifiedSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarClassifiedSuggestion.vue'
import SearchbarSuggestedClassified from '~/components/shared/classified/search/searchbar/suggestions/SearchbarSuggestedClassified.vue'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'

export default defineComponent({
  components: {
    CShimmer,
    SearchbarSuggestedClassified,
    SmartSearchbarClassifiedSuggestion,
    SmartSearchbarActionSuggestion,
    SmartSearchbarAutocompleteSuggestion
  },
  props: {
    section: {
      type: Object as PropType<SmartResultSection>,
      required: true
    },
    sectionIndex: {
      type: Number,
      required: true
    },
    activeRowIndex: {
      type: Number,
      required: true
    },
    hoveredRowIndex: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const classifiedRefs = ref<
      (InstanceType<typeof SmartSearchbarClassifiedSuggestion> | null)[]
    >([])
    const autocompleteRefs = ref<
      (InstanceType<typeof SmartSearchbarAutocompleteSuggestion> | null)[]
    >([])
    const actionRefs = ref<
      (InstanceType<typeof SmartSearchbarActionSuggestion> | null)[]
    >([])

    const triggerClassifiedAtIndex = (index: number, event?: Event) => {
      if (classifiedRefs.value[index]) {
        classifiedRefs.value[index].triggerThumbClick(event || null)
      }
    }

    const getRowElementAtIndex = (index: number): HTMLElement | null => {
      switch (props.section.type) {
        case 'classified':
          return (classifiedRefs.value[index]?.$el as HTMLElement) || null
        case 'autocomplete':
          return (autocompleteRefs.value[index]?.$el as HTMLElement) || null
        case 'action':
          return (actionRefs.value[index]?.$el as HTMLElement) || null
        default:
          return null
      }
    }

    const entryShimmerHeight = computed(() => {
      switch (props.section.type) {
        case 'classified':
          return '68px'
        case 'action':
          return '40px'
        case 'autocomplete':
        default:
          return '30px'
      }
    })

    function getSuggestionKey(suggestion: any, index: number): string {
      switch (props.section.type) {
        case 'autocomplete':
          return (
            'ac-' + (suggestion && suggestion.query ? suggestion.query : index)
          )
        case 'action':
          return (
            'act-' + (suggestion && suggestion.title ? suggestion.title : index)
          )
        case 'classified':
          return (
            'cls-' + (suggestion && suggestion.url ? suggestion.url : index)
          )
        default:
          return String(index)
      }
    }
    const rowClass = (index: number) => {
      if (props.activeRowIndex === index) {
        return 'tw-bg-blue-50'
      }
      if (
        props.activeRowIndex <= -1 &&
        props.hoveredRowIndex > -1 &&
        props.hoveredRowIndex === index
      ) {
        return 'tw-bg-grey-50'
      }
      return ''
    }

    return {
      classifiedRefs,
      autocompleteRefs,
      actionRefs,
      triggerClassifiedAtIndex,
      getRowElementAtIndex,
      entryShimmerHeight,
      getSuggestionKey,
      rowClass
    }
  }
})
